// The /admin/packs search: the version whose diff is open. Anything that is not a pack version is
// dropped, never echoed into a request (the API path is also encoded by the api-client).

// Same rule as the API's :version param. Matches "1.3.4", "1.3.4+2f153de7"; rejects "../x", "1.3".
// https://regex101.com/?flavor=javascript&regex=%5E%5Cd%2B%5C.%5Cd%2B%5C.%5Cd%2B%28%3F%3A-%5B0-9A-Za-z.-%5D%2B%29%3F%28%3F%3A%5C%2B%5B0-9A-Za-z.-%5D%2B%29%3F%24&testString=1.3.4%0A1.3.4%2B2f153de7%0A..%2Fx%0A1.3
const PACK_VERSION = /^\d+\.\d+\.\d+(?:-[0-9A-Za-z.-]+)?(?:\+[0-9A-Za-z.-]+)?$/;
const MAX_VERSION = 32;

export interface PackSearch {
  readonly version?: string | undefined;
}

export function isPackVersion(value: unknown): value is string {
  return typeof value === 'string' && value.length <= MAX_VERSION && PACK_VERSION.test(value);
}

/** The key is always returned so an unvalidated raw value cannot survive the router's merge. */
export function validatePackSearch(search: Record<string, unknown>): PackSearch {
  const raw = search['version'];
  return { version: isPackVersion(raw) ? raw : undefined };
}
